module.exports = __webpack_public_path__ + "static/img/014.0a603d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/014.png
// module id = vJHR
// module chunks = 1